module.exports = __webpack_public_path__ + "img/cards1_front131.491044a5.png";